'use client'

import React from 'react'
import { cn } from '@/lib/utils'

import { Button } from './button'

interface KeyProps {
  value: string
  onClick?: (value: string) => void
  className?: string
  width?: number
}

export const KeyboardKey = ({ value, onClick, className }: KeyProps) => {
  return (
    <Button
      variant={value === '⌫' ? 'ghost' : 'outline'}
      className={cn(
        'keyboard-key h-12 text-lg',
        'transition-transform duration-75 active:scale-95',
        className,
      )}
      onClick={() => onClick?.(value)}
      onKeyDown={(e) => {
        if (e.key === value) {
          onClick?.(value)
        }
      }}
      tabIndex={-1}
    >
      {value === ' ' ? <span className="text-xs">SPACE</span> : value}
    </Button>
  )
}
